/**
 * Text summaries for the 2-D charts (D529): a grid is read as its strongest cells (top and bottom), never as every cell.
 * Locale-neutral like the other builders: the caller injects the labels, the formatter and every separator.
 */
import { isFiniteNumber } from './numbers.js';
/** A sentence for `aria-label`: the title, then the highest (and lowest) cells with their values. */
export function buildGridSummary(options) {
    const cols = options.colLabels.length;
    const sep = options.separator ?? '; ';
    const pair = options.pairSeparator ?? ': ';
    const join = options.cellJoin ?? ' ';
    const cells = options.values
        .map((value, i) => ({ value, row: cols === 0 ? 0 : Math.floor(i / cols), col: cols === 0 ? 0 : i % cols }))
        .filter((c) => isFiniteNumber(c.value));
    if (cells.length === 0)
        return [options.title, options.emptyText].filter((s) => typeof s === 'string' && s !== '').join('. ');
    const describe = (c) => `${options.rowLabels[c.row] ?? ''}${join}${options.colLabels[c.col] ?? ''}${pair}${options.format(c.value)}`;
    const top = Math.max(1, options.top ?? 3);
    const sorted = [...cells].sort((a, b) => b.value - a.value || a.row - b.row || a.col - b.col);
    const highest = sorted.slice(0, top).map(describe).join(sep);
    const lowestCells = sorted.length > top ? sorted.slice(-1).map(describe).join(sep) : '';
    const parts = [options.title, `${options.highestLabel !== undefined ? `${options.highestLabel}${pair}` : ''}${highest}`, lowestCells !== '' ? `${options.lowestLabel !== undefined ? `${options.lowestLabel}${pair}` : ''}${lowestCells}` : ''];
    return parts.filter((s) => typeof s === 'string' && s !== '').join('. ');
}
//# sourceMappingURL=summary-grid.js.map